import { AbstractControl, ValidatorFn } from '@angular/forms';

export function phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: { [key: string]: string | number } } | null => {
        const valid = /^\d{10}$|^\d{3}-\d{3}-\d{4}$/.test(control.value);
        return valid ? null : { 'invalidPhoneNumber': { value: control.value } };
    };
}
